import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import persistStore from "redux-persist/es/persistStore";
import { PersistGate } from "redux-persist/integration/react";
import store from "@/store/store";
import App from "@/App.jsx";
import "bootstrap/dist/css/bootstrap.min.css";
// ignore-no-unused-vars
import * as bootstrap from "bootstrap";
import "@/styles/global.scss";

let persistor = persistStore(store);

window.bootstrap = bootstrap;

if (import.meta.env.MODE !== "development") {
  console.log = () => {};
}

createRoot(document.getElementById("root")).render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>
);
